export default __webpack_public_path__ + "static/media/logInLogo.01f2efa2.svg";